import { useMemo } from "react";
import { ExtractedContract } from "../types/contract";

export const useContractFilterOptions = (
  contracts: ExtractedContract[],
  propertyFilter: string,
  roomFilter: string,
  lesseeFilter: string
) => {
  const contractsFilteredByRoomAndLessee = useMemo(() => {
    const lowerRoom = roomFilter.toLowerCase();
    const lowerLessee = lesseeFilter.toLowerCase();
    return contracts.filter(
      (c) =>
        (c.room_name || "").toLowerCase().includes(lowerRoom) &&
        (c.lessee_name || "").toLowerCase().includes(lowerLessee)
    );
  }, [contracts, roomFilter, lesseeFilter]);

  const propertyOptions = useMemo(
    () =>
      [...new Set(contractsFilteredByRoomAndLessee.map((c) => c.property_name || ""))]
        .filter(Boolean)
        .sort(),
    [contractsFilteredByRoomAndLessee]
  );

  const contractsFilteredByPropertyAndLessee = useMemo(() => {
    const lowerProperty = propertyFilter.toLowerCase();
    const lowerLessee = lesseeFilter.toLowerCase();
    return contracts.filter(
      (c) =>
        (c.property_name || "").toLowerCase().includes(lowerProperty) &&
        (c.lessee_name || "").toLowerCase().includes(lowerLessee)
    );
  }, [contracts, propertyFilter, lesseeFilter]);

  const roomOptions = useMemo(
    () =>
      [...new Set(contractsFilteredByPropertyAndLessee.map((c) => c.room_name || ""))]
        .filter(Boolean)
        .sort(),
    [contractsFilteredByPropertyAndLessee]
  );

  const contractsFilteredByPropertyAndRoom = useMemo(() => {
    const lowerProperty = propertyFilter.toLowerCase();
    const lowerRoom = roomFilter.toLowerCase();
    return contracts.filter(
      (c) =>
        (c.property_name || "").toLowerCase().includes(lowerProperty) &&
        (c.room_name || "").toLowerCase().includes(lowerRoom)
    );
  }, [contracts, propertyFilter, roomFilter]);

  const lesseeOptions = useMemo(
    () =>
      [...new Set(contractsFilteredByPropertyAndRoom.map((c) => c.lessee_name || ""))]
        .filter(Boolean)
        .sort(),
    [contractsFilteredByPropertyAndRoom]
  );

  const filteredContracts = useMemo(() => {
    const lowerLessee = lesseeFilter.toLowerCase();
    return contractsFilteredByPropertyAndRoom.filter(
      (c) => (c.lessee_name || "").toLowerCase().includes(lowerLessee)
    );
  }, [contractsFilteredByPropertyAndRoom, lesseeFilter]);

  return {
    filteredContracts,
    propertyOptions,
    roomOptions,
    lesseeOptions,
  };
};
